import Validators from '../validators'

// contract_share
export default (store) => store.createEmbededEntityState({
  attrs: ['contractor_id', 'share', 'platform', 'right_type', 'source_of_revenues_cd'],
  titles: [store.__('contractor'), store.__('share (%)'), store.__('platform'),
    store.__('right type'), store.__('limited to source of revenues')],
  _sortField: 'right_type',
  // TODO: ['right_type', 'share'],
  // TODO: _sortDir: ['asc', 'desc'],
  initVals: (row) => ({ share: 50, control_timestamp: Math.round(new Date().getTime()) }),
  validators: {
    _global: (vals, items) => {
      // Validate for same contractor in same right_type twice!
      if (items.find(i => !((vals.get('id') && i.id && vals.get('id') === i.id) ||
        (vals.get('control_timestamp') && i.control_timestamp && vals.get('control_timestamp') === i.control_timestamp)) &&
        i.contractor_id === vals.get('contractor_id') &&
        i.platform === (vals.get('platform') || null) &&
        i.right_type === (vals.get('right_type') || null) &&
        i.platform === vals.get('source_of_revenues_cd'))
      ) {
        return store.__('Only one contractor per same "Platform/Right type" is alowed.')
      }

      const shares = {}
      for (const item of items) {
        const key1 = item.platform + item.right_type + (item.source_of_revenues_cd || '')
        const key2 = vals.get('platform') + vals.get('right_type') +
          (vals.has('source_of_revenues_cd') ? vals.get('source_of_revenues_cd') : '')
        shares[key1] = (
          (shares[key1] || 0) +
          (((vals.get('id') && item.id && vals.get('id') === item.id) ||
            (vals.get('control_timestamp') && item.control_timestamp && vals.get('control_timestamp') === item.control_timestamp))
            ? 0
            : parseFloat(item.share)
          )
        )
        if (key1 === key2 &&
          (shares[key1] + parseFloat(vals.get('share')) > 100 ||
            shares[key1] + parseFloat(vals.get('share')) < 1)
        ) {
          return store.__('Total share per Platform/Right type (or with Limited to source of revenues) must be 100%.')
        }
      }
    },
    contractor_id: Validators.isMandatory(store),
    share: [
      Validators.isMandatory(store),
      (val) => {
        if (parseFloat(val) > 100 || parseFloat(val) < 0) {
          return store.__('Share must be between 0 and 100.')
        }
      }
    ],
    platform: Validators.isMandatory(store),
    right_type: Validators.isMandatory(store)
  }
})
